import React from 'react';
import { withTranslation } from '../../../Translator';
import Button from '../../../Button';
import FormContext from '../../../../utils/hoc/formHelpers/context';

class Cancel extends React.PureComponent {
  static contextType = FormContext;

  render() {
    const { t, text } = this.props;
    const { isSubmitting } = this.context;

    return (
      <Button
        text={text || t('cancel')}
        disabled={isSubmitting}
        {...this.props}
      />
    );
  }
}

export default withTranslation('components')(Cancel);
